export default __webpack_public_path__ + "static/media/u5.2faed87a.jfif";